export const preparationType = Object.freeze({
    0: "Not Specified",
    1: "Tray",
    2: "Regular"
});
